<template lang="html">
  <section class="hit-calculator-checkboxes-checked-by-default-settings settings">
    <header>
      <h1 class="page-header">Hit calculator checkboxes checked by default</h1>
    </header>
  </section>
</template>

<script>
export default {
  name: 'hit-calculator-checkboxes-checked-by-default-settings',
};
</script>

<style lang="scss" scoped>
  @import 'src/assets/settings';
</style>



// WEBPACK FOOTER //
// src/components/settings/hit-calculator/checkboxes/checked-by-default.vue